import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { CloudImage } from '@components/CloudImage';
import { themeMediaQuery, themeSpace, themeVariant } from '@utils/styledTheme.util';

export const StyledCloudImage = styled(CloudImage)`
  border-radius: ${themeSpace(3)};
  transition: transform 0.8s ease;
`;

export const Department = styled(Flex)`
  width: 270px;
  height: 303px;
  border-radius: ${themeSpace(3)};
  position: relative;
  overflow: hidden;
  transition: transform 0.5s ease;

  &:hover {
    transform: scale(1.05);
    ${StyledCloudImage} {
      transform: scale(1.15);
    }
  }

  ${themeMediaQuery('below_sm')} {
    width: 193px;
    height: 217px;
  }
`;

export const StyledSliderWrapper = styled(Box)`
  ${themeMediaQuery('sm')} {
    padding-top: ${themeSpace(3)};
  }
  ${themeMediaQuery('below_sm')} {
    .react-horizontal-scrolling-menu--scroll-container {
      padding: 0;
    }
    .react-horizontal-scrolling-menu--scroll-container::-webkit-scrollbar-track {
      margin: 0;
    }
  }
`;
